<template>
  <el-card>
    <div slot="header">
      HR adatok
    </div>
    <el-form
      ref="hrForm"
      :model="hrData"
      label-position="top"
      autocomplete="off"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="nick_name"
            label="Becenév"
          >
            <el-input
              v-model="hrData.nick_name"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="birth_name"
            label="Születési név"
          >
            <el-input
              v-model="hrData.birth_name"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="birth_place"
            label="Születési hely"
          >
            <el-input
              v-model="hrData.birth_place"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="birth_date"
            label="Születési idő"
          >
            <el-date-picker
              v-model="hrData.birth_date"
              type="date"
              style="width: 100%;"
              :clearable="false"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="id_card_number"
            label="Szig. szám"
          >
            <el-input
              v-model="hrData.id_card_number"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="social_insurance_number"
            label="TB szám"
          >
            <el-input
              v-model="hrData.social_insurance_number"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="tax_id_number"
            label="Adóazonosító jel"
          >
            <el-input
              v-model="hrData.tax_id_number"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="tax_number"
            label="Adószám"
          >
            <el-input
              v-model="hrData.tax_number"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="private_email"
            label="Privát Email"
          >
            <el-input
              v-model="hrData.private_email"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="private_mobile"
            label="Privát Mobil"
          >
            <el-input
              v-model="hrData.private_mobile"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="leader_user"
            label="Területi vezető"
          >
            <el-select
              v-model="hrData.leader_user_id"
              filterable
              placeholder="Válassz területi vezetőt"
              style="width: 100%;"
            >
              <el-option
                v-for="leaderUser in users"
                :label="leaderUser.last_name +' '+ leaderUser.first_name"
                :value="leaderUser.id"
                :key="leaderUser.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="location"
            label="Terület"
          >
            <el-select
              v-model="hrData.locations"
              filterable
              multiple
              placeholder="Válassz területet"
              style="width: 100%;"
            >
              <el-option
                v-for="location in locations"
                :label="location.value"
                :value="location.id"
                :key="location.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>
<script>
  export default {
    props: ['user'],
    data() {
      return {
        hrData: {},
      };
    },
    computed: {
      locations() {
        return this.$store.getters['location/locations'];
      },
      users() {
        return this.$store.getters['user/users'];
      }
    },
    watch: {
      user(newVal) {
        const data = JSON.parse(JSON.stringify(newVal));
        this.hrData = {
          private_mobile: data.private_mobile,
          private_email: data.private_email,
          nick_name: data.nick_name,
          birth_name: data.birth_name,
          birth_date: data.birth_date,
          birth_place: data.birth_place,
          id_card_number: data.id_card_number,
          social_insurance_number: data.social_insurance_number,
          tax_id_number: data.tax_id_number,
          tax_number: data.tax_number,
          locations: data.locations,
          leader_user_id: data.leader_user_id,
        };
      },
    },
    methods: {
      add() {
        this.$emit('add');
      }
    }
  };
</script>
